import { createSelector } from 'reselect';

import type { RootState } from '/business/shared/state/store';

import getBasketMetaDeepInspectionSelector from './getBasketMetaDeepInspectionSelector';

export default createSelector(
  [(state: RootState) => getBasketMetaDeepInspectionSelector(state, 'projections', [])],
  (projections) => {
    const finalProjection = projections[projections.length - 1];

    return (
      typeof finalProjection?.targetYear === 'number' &&
      (finalProjection.projectedPercentage ?? 0) > 0 &&
      typeof finalProjection.individualScopeTargets === 'boolean'
    );
  },
);
